import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface TripsheetDateFilterState {
  tripsheetDateFilter: {date: Date};
  setTripsheetDateFilter: (tripsheetDateFilter: {date: Date}) => void;
}

export const useTripsheetDateFilterStore = create<TripsheetDateFilterState>()(
  devtools(
    (set) => ({
      tripsheetDateFilter: {date: new Date()},
      setTripsheetDateFilter: (newTripsheetDateFilter) =>
        set(() => ({
          tripsheetDateFilter: {date: new Date(newTripsheetDateFilter.date)}
        })),
    }),
    { name: "TripsheetDateFilterStore" }
  )
);

